import { useEffect } from 'react';
import { queryClient } from '@app/query/queryClient';
import { syncEngine } from '@services/offline/syncEngine';
import { syncQueueQueryKey } from './useSyncQueue';

export const useSyncOnReconnect = () => {
  useEffect(() => {
    const run = () => {
      void syncEngine
        .processQueue()
        .then(() => queryClient.invalidateQueries({ queryKey: syncQueueQueryKey }));
    };

    window.addEventListener('online', run);
    run();

    return () => window.removeEventListener('online', run);
  }, []);
};
